var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-time"},[_c('div',{staticClass:"date mr-2"},[_c('date',{attrs:{"value":_vm.value},on:{"input":_vm.changeDate}})],1),_vm._v(" "),_c('div',{staticClass:"time"},[_c('hour',{attrs:{"value":_vm.hourMinute},on:{"input":_vm.changeHour}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f90d410","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fields/DateTime.vue
// module id = null
// module chunks = 